export default function StatsBar() {
  const stats = [
    { value: "14+", label: "Curated Categories" },
    { value: "100k+", label: "Monthly Research Sessions" },
    { value: "2026", label: "Latest Sheet Edition" },
  ];

  return (
    <section className="relative bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Title */}
          <div className="lg:w-5/12 flex-shrink-0">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Your Ultimate
              <br />
              Shopping Research
              <br />
              <span className="text-primary-500">Companion</span>
            </h2>
          </div>

          {/* Right: Stats */}
          <div className="lg:w-7/12 flex-1">
            <div className="grid grid-cols-3 gap-6 md:gap-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-4xl md:text-5xl font-bold text-accent-500">
                    {stat.value}
                  </div>
                  <div className="mt-2 text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}